module.exports = "<aside class=\"col-xs-3 col-sm-4 col-md-3\">\n  <div>\n    <pax-cf-monthly-rate></pax-cf-monthly-rate>\n    <pax-cf-nav></pax-cf-nav>\n  </div>\n</aside>\n<main class=\"col-xs-9 col-sm-8 col-md-9\">\n  <router-outlet (activate)=\"onActivate($event, outlet)\" #outlet></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/app/coverage-form/coverage-form.component.html
// module id = 556
// module chunks = 1